// extracted by mini-css-extract-plugin
export var button = "CardVerificationStep-module--button--f2afd";
export var card = "CardVerificationStep-module--card--e356c";
export var danger = "CardVerificationStep-module--danger--ce45c";